import React from 'react';
import { Home, MessageSquare, PlusCircle, Package, Settings } from 'lucide-react';
import { motion } from 'framer-motion';
interface TabBarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
export function TabBar({
  activeTab,
  onTabChange
}: TabBarProps) {
  const tabs = [{
    id: 'home',
    label: 'Home',
    icon: Home
  }, {
    id: 'activity',
    label: 'Activity',
    icon: MessageSquare
  }, {
    id: 'list',
    label: 'Add Listing',
    icon: PlusCircle
  }, {
    id: 'my-stuff',
    label: 'My Stuff',
    icon: Package
  }, {
    id: 'settings',
    label: 'Settings',
    icon: Settings
  }];
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-sand z-50" data-id="element-459">
      <div className="max-w-md mx-auto flex justify-around items-center h-20 pb-safe relative" data-id="element-460">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <motion.button key={tab.id} whileTap={{
          scale: 0.9
        }} onClick={() => onTabChange(tab.id)} className="flex flex-col items-center justify-center gap-1 flex-1 h-full relative" data-id="element-461">
              {isActive && <motion.div layoutId="activeTab" className="absolute inset-x-2 top-0 h-1 bg-dark-green rounded-full" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-462" />}
              <Icon size={24} className={isActive ? 'text-dark-green' : 'text-moss-gray'} data-id="element-463" />
              <span className={`text-[10px] font-medium ${isActive ? 'text-dark-green' : 'text-moss-gray'}`} data-id="element-464">
                {tab.label}
              </span>
            </motion.button>;
      })}
      </div>
    </div>;
}